export const SLICE_NAME = 'carbon';
